module.exports = __webpack_public_path__ + "img/activate.a6e38002.svg";